import {onMounted, onUnmounted, ref} from "vue";

const LS_COLOR_SCHEME_KEY = 'sezUs:scheme';

function applyScheme(scheme, persist = false) {
  document.documentElement.setAttribute('scheme', scheme);
  if (scheme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
  if (persist) {
    localStorage.setItem(LS_COLOR_SCHEME_KEY, scheme);
  }
}

function getSystemScheme() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function getSavedScheme() {
  return localStorage.getItem(LS_COLOR_SCHEME_KEY);
}

function removeSavedScheme() {
  localStorage.removeItem(LS_COLOR_SCHEME_KEY);
}

function initSystemSchemeListener() {
  const matchMedia = window.matchMedia('(prefers-color-scheme: dark)');
  const updateScheme = () => {
    const savedScheme = getSavedScheme();
    if (!savedScheme) {
      applyScheme(getSystemScheme());
    }
  };

  matchMedia.addEventListener('change', updateScheme);
  updateScheme();

  return () => {
    matchMedia.removeEventListener('change', updateScheme);
  };
}

function useSchemeObserver() {
  const currentScheme = ref(document.documentElement.getAttribute('scheme') || 'dark');

  let observer;

  const startObserver = () => {
    observer = new MutationObserver(() => {
      currentScheme.value = document.documentElement.getAttribute('scheme') || 'dark';
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['scheme'],
    });
  };

  const stopObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  onMounted(startObserver);
  onUnmounted(stopObserver);

  return currentScheme;
}

export { applyScheme, getSystemScheme, getSavedScheme, removeSavedScheme, initSystemSchemeListener, useSchemeObserver };
